module.exports = __webpack_public_path__ + "static/region_map-5fee4e2265cb66de9ac19795994ab484.png";